import React, { ReactElement } from 'react';

const MyFoldersSharedFoldersDisclaimers = (): ReactElement => (
  <p>
    Folders that are shared are visible to, and editable by, all Storyblocks
    users within your organization.
  </p>
);

export default MyFoldersSharedFoldersDisclaimers;
